export class KeyValue {
    key!:String;
    value!: String;
    father!: String;
    id!: String;
    email!: string;
    link!: string;
}